"use strict";

import React, { Component } from "react";
import moment from "moment";

import ReactTable from "react-table";
import "react-table/react-table.css";

import ViolationLevelIcon from "../../component/EnrichedVideo/Widget/ViolationLevelIcon";

import { getRequest } from "../../service/api/request";

import { apiPath } from "../../const";
import EnrichedVideoWidget from "../../component/EnrichedVideo/Widget/EnrichedVideo";
import Section from "../../component/Template/Section";

class EnrichedVideo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            enrichedVideo: null,
            enrichedVideoId: this.props.match.params.enrichedVideoId,
            loading: true,
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.match.params.enrichedVideoId !== this.props.match.params.enrichedVideoId) {
            const enrichedVideoId = this.props.match.params.enrichedVideoId;
            this.setState({ enrichedVideoId });
            this.fetchData();
        }
    }

    fetchData() {
        this.setState({ loading: true });
        const {enrichedVideoId} = this.state;
        const reportApiPath = `${apiPath}/enrichedVideos/${enrichedVideoId}`;
        let params = {};

        getRequest(
            reportApiPath,
            params
        ).then(response => {
            this.setState({
                enrichedVideo: response.entity,
                loading: false,
            });
        });
    }

    render() {
        const { enrichedVideoId, enrichedVideo } = this.state;

        return (
            <div>
                <Section className="content-header">
                    { enrichedVideo &&
                      <h1>Enriched Video
                          <small>{ enrichedVideoId } -
                                 { enrichedVideo.program &&
                                   `${enrichedVideo.program.title} S ${enrichedVideo.seasonNumber} E ${enrichedVideo.episode} - ` }
                                 { enrichedVideo.title }</small></h1> }
                </Section>
                <Section className="content">
                    { enrichedVideo &&
                      <EnrichedVideoWidget enrichedVideoId={enrichedVideoId} enrichedVideo={enrichedVideo} /> }
                </Section>
            </div>
        )
    }
}

export default EnrichedVideo;
